import type { FunctionComponent } from "react";

interface IconNotifyProps {
  color?: string;
}

const IconNotify: FunctionComponent<IconNotifyProps> = ({
  color = "#000000",
}) => {
  return (
    <svg
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.1894 24.0468C26.2994 23.2534 25.5202 22.3439 24.8728 21.3426C24.1661 19.9606 23.7425 18.4513 23.6269 16.9034V12.3441C23.633 9.91278 22.751 7.56288 21.1467 5.73595C19.5424 3.90902 17.3262 2.73081 14.9145 2.42268V1.2321C14.9145 0.90533 14.7847 0.59194 14.5536 0.360875C14.3225 0.129811 14.0091 0 13.6824 0C13.3556 0 13.0422 0.129811 12.8111 0.360875C12.5801 0.59194 12.4503 0.90533 12.4503 1.2321V2.44114C10.0601 2.77148 7.87068 3.95681 6.28745 5.77761C4.70423 7.5984 3.8345 9.93127 3.83937 12.3441V16.9034C3.72378 18.4513 3.30017 19.9606 2.59342 21.3426C1.95741 22.3416 1.19075 23.251 0.313795 24.0468C0.215347 24.1333 0.136446 24.2398 0.082341 24.3591C0.0282355 24.4785 0.000165938 24.608 0 24.739V25.9942C0 26.239 0.0972364 26.4737 0.270318 26.6468C0.4434 26.8199 0.67815 26.9171 0.922925 26.9171H26.5802C26.825 26.9171 27.0598 26.8199 27.2328 26.6468C27.4059 26.4737 27.5032 26.239 27.5032 25.9942V24.739C27.503 24.608 27.4749 24.4785 27.4208 24.3591C27.3667 24.2398 27.2878 24.1333 27.1894 24.0468ZM1.91968 25.0713C2.77838 24.2417 3.53443 23.3122 4.17162 22.3025C5.06188 20.6333 5.58132 18.7917 5.69445 16.9034V12.3441C5.65784 11.2625 5.83928 10.1845 6.22794 9.17449C6.6166 8.16443 7.20455 7.24291 7.95676 6.46481C8.70898 5.68671 9.61008 5.06793 10.6064 4.64533C11.6028 4.22273 12.6739 4.00495 13.7562 4.00495C14.8384 4.00495 15.9096 4.22273 16.906 4.64533C17.9023 5.06793 18.8034 5.68671 19.5556 6.46481C20.3078 7.24291 20.8958 8.16443 21.2845 9.17449C21.6731 10.1845 21.8545 11.2625 21.8179 12.3441V16.9034C21.9311 18.7917 22.4505 20.6333 23.3408 22.3025C23.978 23.3122 24.734 24.2417 25.5927 25.0713H1.91968Z"
        fill={color}
      />
      <path
        d="M13.7977 29.9997C14.379 29.9863 14.937 29.7678 15.3727 29.3827C15.8085 28.9976 16.094 28.4708 16.1788 27.8955H11.3242C11.4114 28.4864 11.7103 29.0256 12.1653 29.4127C12.6203 29.7997 13.2004 30.0084 13.7977 29.9997Z"
        fill={color}
      />
    </svg>
  );
};

export default IconNotify;
